import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormAutoCompleteField, {
  MxFormAutoCompleteFieldProps
} from "@rf-l2/form/select/MxFormAutoCompleteField";

interface MxFormL3AutoCompleteProps extends MxFormAutoCompleteFieldProps {
  name: string;
  withreacthookform?: 1 | 0;
}
function MxFormL3AutoComplete(props: MxFormL3AutoCompleteProps) {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormAutoCompleteField label={props.label} {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
}

export default MxFormL3AutoComplete;
